import { request } from "./httpClient";

function getUrl(prefixKey) {
    const prefix = (window.appConfig && window.appConfig[prefixKey]);
    return process.env.REACT_APP_API_URL + prefix;
}

export async function fetchHealthCheckBySiteId({ queryKey }) {
    const [, siteId, timeout] = queryKey;
    const url = `${getUrl("getHealthCheckUrl")}${siteId}`;
    return request(url, {}, timeout);
}